import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CheckboxGroup, Checkbox } from '@guardian/src-checkbox';
import { FieldLabel } from './FieldLabel';
export const CheckboxSelect = ({ formField, formData, setFormData }) => (_jsxs(_Fragment, { children: [_jsx(FieldLabel, { formField: formField }, void 0), _jsx(CheckboxGroup, Object.assign({ name: formField.name }, { children: formField.options.map((option, index) => {
                // data related to this field is mapped to `formData` using `formField.id`
                // We cannot assume that the data exists, so we need to check if `formField.id` key exists in `formData`
                const selectedCheckboxesArray = formField.id in formData ? formData[formField.id] : [];
                const isCheckboxChecked = !!selectedCheckboxesArray.find((ele) => ele === option.value);
                const filterOutCheckboxFromArray = () => selectedCheckboxesArray.filter((ele) => ele !== option.value);
                const addCheckboxToArray = () => [
                    ...selectedCheckboxesArray,
                    option.value,
                ];
                return (_jsx(Checkbox, { "data-testid": `form-field-${option.value}`, label: option.label, value: option.value, checked: isCheckboxChecked, onChange: () => {
                        setFormData({
                            ...formData,
                            [formField.id]: isCheckboxChecked
                                ? filterOutCheckboxFromArray()
                                : addCheckboxToArray(),
                        });
                    } }, index));
            }) }), void 0)] }, void 0));
